import i18n from "@/plugins/i18n";

function getConferenceManagementColumns(handlers) {
  return getColumns(handlers, conferenceManagementColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const conferenceManagementColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    sortBy: "title",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: 'edit',
        handler: null,
      },
    ],
  },
];

export { getConferenceManagementColumns };
